'use client';
import React from 'react';
import cn from './style.module.scss';
export default function ContentData(props: any) {
  const { t } = props;
  return (
    <div className={cn.contentData}>
      <div className={cn.dataElement}>
        <h2>{t['themeContentTitle']}</h2>
        <p>{t['themeLaunchDesc']}</p>
      </div>
    </div>
  );
}
